import { AppliedPromoCode } from "@/components/shared/PromoCode/AppliedPromoCode";
import { PromoCodeField } from "@/components/shared/PromoCode/PromoCodeField";
import { cn } from "@/utils/cn";
import { CartUISection } from "../ui";

type CouponCodeProps = {
  isApplying?: boolean;
  className?: string;
  currency?: string;
  field?: {
    placeholder: string;
    value: string;
    setValue: (value: string) => void;
    codeInvalid: boolean;
  };
  cta?: {
    label: string;
    action: () => void;
    disabled?: boolean;
  };
  appliedStates: {
    code: string;
    message?: string;
    percent_off?: number | null;
    amount_off?: number | null;
    isSticky?: boolean; // pre-applied, non-removable discount (e.g. from a referral credit)
    isRemoving?: boolean;
    onRemove?: () => void;
  }[];
};

export const CouponCode = (props: CouponCodeProps) => {
  const { isApplying, className, currency, field, cta, appliedStates } = props;

  return (
    <CartUISection>
      <div className={cn(className)}>
        {field && cta && (
          <PromoCodeField
            placeholder={field.placeholder}
            applyText={cta.label}
            promoCode={{
              inputValue: field.value,
              setInputValue: field.setValue,
              handleApply: cta.action,
              isApplying: isApplying,
              isInvalid: field.codeInvalid,
            }}
          />
        )}

        {appliedStates.map((state) => (
          <AppliedPromoCode key={state.code} {...state} currency={currency} />
        ))}
      </div>
    </CartUISection>
  );
};
